var $ = require('jquery');

var Articles = function($target) {

	var self = this;
	self.link = $('.show-more a');

	function init() {

		if (self.link.length) { 
			article_show_more(); 
		}
	}

	function article_show_more() {

		$(document).on('click', '.show-more a', function(e) {
			load_next_page(e);
		});
	}

	function load_next_page(e) {
		e.preventDefault();
		self.link = $(e.target);
		self.link.attr('href');
		$.get(self.link.attr('href'), page_loaded);
	}

	function page_loaded(data) {

		data = $(data);
		var newPosts = data.find('.articles .card');
		var nextMoreLink = data.find('.show-more a');

		if (newPosts.length) {
			$('.articles').append(newPosts);
		}
		
		if (nextMoreLink.length) {

			var href = nextMoreLink.attr('href');
			self.link.attr('href',href);

		} else {

			self.link.off('click').removeAttr('href').addClass('inactive');
		}

		$('html, body').animate({ scrollTop: newPosts.offset().top }, 300);
	}

	self.load_articles = function(data) {

	    // Add WP action and secrity to data array
	    data.action = 'load_articles';
	    data.security = GLOBALS.AJAX_NONCE;

		$.get(GLOBALS.ADMIN_URL, data).done(function(response) {
			show_articles(response);
		});
	};

	function show_articles(data) {

		$('.results').hide();
		$('.results').html(data);
		$('.results').fadeIn(1000);
	}

	init();
};

module.exports = Articles;